module.exports = __webpack_public_path__ + "static/monikawork5-192d81ff144ce6aa5b27f48dcdb6e546.jpg";